<template>
  <svg class="icon" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M22.2739 12.8995L23.3345 11.8388L22.2739 10.7782L14.4957 3L12.3744 5.12132L17.5919 10.3388H1L1 13.3388H17.5919L12.3744 18.5563L14.4957 20.6777L22.2739 12.8995Z"
    />
  </svg>
</template>
